<template>
  <div class="partners" id="partners">
    <div class="header" :style="{backgroundColor:isComing?'#ff3c00':'#fff'}">
      <img src="https://summit-img.geekpark.net/mobile/%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4-%E9%BB%91%E8%89%B2.png"
           v-show="!isComing">
      <img src="https://summit-img.geekpark.net/mobile/%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4-%E7%99%BD%E8%89%B2.png" v-show="isComing">
    </div>
    <div class="content">
      <div class="box" v-for="(category,index) in partner_categories" :key="index">
        <p>{{category.name}}</p>
        <div class="images-box">
          <img :src="item.logo.url" v-for="item in category.partners" :key="item.logo.url">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Partners',
  props: ['partner_categories'],
  data () {
    return {
      isComing: false
    }
  },
  mounted () {
    // window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    getElementTop (element) {
      let actualTop = element.offsetTop
      let current = element.offsetParent

      while (current !== null) {
        actualTop += current.offsetTop
        current = current.offsetParent
      }

      return actualTop
    },
    handleScroll () {
      const scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const partnersTop = this.getElementTop(document.querySelector('#partners'))
      if (scrollHeight > partnersTop - 400) {
        this.isComing = true
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="less">
  .partners {
    margin-top: 10vw;
    margin-bottom: 10vw;
  }

  .header {
    box-sizing: border-box;
    width: 90vw;
    margin: auto;
    padding: 8vw 0;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    text-align: left;
    transition: background-color .7s;

    img {
      width: 80vw;
      margin-left: 3vw;
    }
  }

  .content {
    width: 100vw;
    margin: auto;
  }

  .box {
    margin-top: 8vw;

    p {
      margin-bottom: 2vw;
      text-align: center;
      font-size: 4vw;
    }

    .images-box {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;

      img {
        width: 25vw;
        height: 12.5vw;
      }
    }
  }
</style>
